import { c as _c } from "react/compiler-runtime";
import { anyspendService } from "../../../anyspend/services/anyspend.js";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export function useAnyspendTokenList(chainId, query) {
  const $ = _c(9);
  let t0;
  if ($[0] !== chainId || $[1] !== query) {
    t0 = {
      queryKey: ["getAnyspendTokenList", chainId, query],
      queryFn: () => anyspendService.getTokenList(chainId, query),
      enabled: true
    };
    $[0] = chainId;
    $[1] = query;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data: t1,
    isLoading,
    refetch
  } = useQuery(t0);
  let t2;
  if ($[3] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const data = t2;
  let t3;
  let t4;
  if ($[5] !== data || $[6] !== isLoading || $[7] !== refetch) {
    t4 = {
      data,
      isLoading,
      refetch
    };
    $[5] = data;
    $[6] = isLoading;
    $[7] = refetch;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  t3 = t4;
  return t3;
}